





























































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getList, remove } from '@/api/videoDevice/index'
import {
  updateDeviceOnline, updateCameraOnline
} from '@/api/cam/index'
import { DDLItem, DefDDLItem } from '@/api/common/select'
import { enFirstType } from '@/configs/enums'
import {
  getSubDDL, copyArray, toDefaultStr, toDefaultInt, tryToStr, tryToInt, jsonStoreage
} from '@/configs/functions'
import PageList from '@/components/pageLayout/list.vue'

import {
  PagePermissionState, PermissionData, FailedPermission
} from '@/store/modules/pagePermission'
import { UserData } from '@/api/systemManage/user'
import { namespace } from 'vuex-class'
const UserModule = namespace('user')
const PagePermissionModule = namespace('pagePermission')
const DataSourceModule = namespace('dataSource')

@Component({
  components: {
    PageList
  }
})
export default class DeviceList extends Vue {
  public showMore: boolean = false
  @PagePermissionModule.Getter
  public pagePermission!: PagePermissionState
  public btnCtrl: PermissionData = FailedPermission
  public pagePath: string = ''
  public getPermission() {
    const s = this.pagePermission
    let p = FailedPermission
    let path = ''
    if (this.$route.path.indexOf(s.pagePath) > -1) {
      p = s.permission
      path = s.pagePath
    }
    this.btnCtrl = p
    this.pagePath = path
    var cacheQuery = jsonStoreage.getFilter(path)
    if (cacheQuery && cacheQuery != null) {
      this.queryTerm = Object.assign({}, cacheQuery)
      jsonStoreage.removeFilter(path)
    }
    else {
      this.getQueryTerm()
    }
  }
  @UserModule.Getter('userInfo')
  public curUser!: UserData

  public listLoading: boolean = true
  public totalItems: number = 0
  public totalPages: number = 0
  public pageSize: number = window.baseConfig.PageSize

  public firstType: number = enFirstType.All
  public defItem: DDLItem = DefDDLItem(this.firstType)

  public levelList: DDLItem[] = []
  public classifyList: DDLItem[] = []
  public cityList: DDLItem[] = []
  public countyList: DDLItem[] = [this.defItem]
  //0全部 1离线 2在线 
  public onlineStatusList = [
    { Key: 0, Val: '--全部--' },
    { Key: 1, Val: '离线' },
    { Key: 2, Val: '在线' },
    { Key: 3, Val: '未知' }
  ]
  public list: any[] = []
  public queryTerm = {
    Page: 1,
    PageSize: this.pageSize,
    SortBy: 'UpdateDate',
    IsAsc: false,

    LevelId: 0,
    ClassifyId: 0,
    CityId: 0,
    CountyId: 0,

    OnlineStatus: 0,
    Status: 0,
    Keyword: ''
  }
  // 保存最新的一次查询参数，用来保证分页，排序，导出时保证查询条件不变
  public lastQuery = Object.assign({}, this.queryTerm)
  public getQueryTerm() {
    const query = this.$route.query
    // 从页面Url中获取参数
    this.queryTerm = {
      PageSize: toDefaultInt(query['PageSize'], this.pageSize),
      Page: toDefaultInt(query['Page'], 1),
      SortBy: toDefaultStr(query['SortBy'], 'UpdateDate'),
      IsAsc: tryToStr(query['IsAsc']) == 'true',

      LevelId: tryToInt(query['LevelId']),
      ClassifyId: tryToInt(query['ClassifyId']),
      CityId: tryToInt(query['CityId']),
      CountyId: tryToInt(query['CountyId']),
      OnlineStatus: tryToInt(query['OnlineStatus']),
      Status: tryToInt(query['Status']),
      Keyword: tryToStr(query['Keyword'])
    }
  }
  get startIndex() {
    return this.queryTerm.PageSize * (this.queryTerm.Page - 1) + 1
  }
  get tableSort() {
    return {
      prop: this.queryTerm.SortBy,
      order: this.queryTerm.IsAsc ? 'ascending' : 'descending'
    }
  }
  //页面控制
  public setRowClass(data: { row: any, rowIndex: number }) {
    const row = data.row
    let name = ''
    if (row.IsSourceDelete > 0) {
      //源视频已删除
      name = 'color-info'
    }
    return name
  }
  // 选中项,这里存的是整个行的数据
  public selectedRows: any[] = []
  // 多选的时候，用到，返回选中的行，这里存的是数组
  public selectedChange(val: never[]) {
    this.selectedRows = val
  }
  // 点击排序按钮的时候，按新排序查询数据
  public sortChange(col: { [key: string]: string }) {
    const query = this.lastQuery
    const asc = col.order === 'ascending' // descending
    if (query.SortBy !== col.prop || query.IsAsc !== asc) {
      query.SortBy = col.prop
      query.IsAsc = asc
      this.refreshData()
    }
  }
  // 分页按钮点击的时候，按新分页查询数据
  public pageEvent() {
    const qt = this.queryTerm
    const query = this.lastQuery
    query.Page = qt.Page
    query.PageSize = qt.PageSize
    this.refreshData()
  }
  // 点击查询按钮时，页码需要重置为1
  public doSearch() {
    this.queryTerm.Page = 1
    this.fetchData(this.queryTerm)
  }
  public created() {
    this.getPermission()
    this.fetchSource()
  }
  public mounted() {
    // this.doSearch()
  }
  public beforeDestroy() { }
  @DataSourceModule.Getter('unitLevel')
  public unitLevel!: any
  @DataSourceModule.Getter('unitClassify')
  public unitClassify!: any
  @DataSourceModule.Getter('cityList')
  public cityCounty!: any
  @DataSourceModule.Getter('dataSource')
  public dataSource!: any
  public fetchSource() {
    var unitLevel = copyArray(this.unitLevel)
    if (unitLevel) {
      this.levelList = unitLevel
    }
    var unitClassify = copyArray(this.unitClassify)
    if (unitClassify) {
      this.classifyList = unitClassify
    }
    var cityCounty = copyArray(this.cityCounty)
    if (cityCounty) {
      this.cityList = cityCounty
      if (cityCounty.length == 2) {
        this.queryTerm.CityId = cityCounty[1].Key
      }
      if (this.queryTerm.CityId > 0) {
        this.cityChange(0)
      }
    }
    const data = Object.assign({}, this.dataSource)
    if (data) {
      // this.protocolList = data.protocolList
    }
  }
  public cityChange(reset: number) {
    const qt = this.queryTerm
    this.countyList = [this.defItem]
    if (reset === 1) {
      qt.CountyId = 0
    }
    if (qt.CityId > 0) {
      this.countyList = getSubDDL(this.cityList, qt.CityId)
      if (this.countyList.length == 1) {
        qt.CountyId = this.countyList[0].Key
      }
    }
  }
  public fetchData(query: any) {
    this.listLoading = true
    getList(query).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.list = data.Results
        this.totalPages = data.TotalPages
        this.totalItems = data.TotalCount

        this.queryTerm.PageSize = data.PageSize
        this.queryTerm.Page = query.Page
        this.queryTerm.SortBy = query.SortBy
        this.queryTerm.IsAsc = query.IsAsc

        this.lastQuery = Object.assign({}, query)
        jsonStoreage.setFilter(this.pagePath, query)
      }
      this.listLoading = false
    })
  }
  public refreshData() {
    this.fetchData(this.lastQuery)
  }
  public doAdd() {
    this.$router.push({ path: '/VideoList/New' })
  }
  public doDiscover() {
    this.$router.push({ path: '/VideoList/Discover' })
  }
  public updateDeviceOnline() {
    updateDeviceOnline().then((response: { data: any }) => {
      const data = response.data
      if (data && !data.IsError) {
        this.$message({
          type: 'success',
          message: '设备在线状态更新成功!'
        })
        this.refreshData()
      } else {
        this.$message({
          dangerouslyUseHTMLString: true, message: `${data.Message}`,
          type: 'warning'
        })
        console.log('设备在线状态更新失败', data)
      }
    })
  }
  public updateCameraOnline() {
    if (this.list.length > 50) {
      this.$message('需要同步的数据比较多，请耐心等待!')
    }
    updateCameraOnline().then((response: { data: any }) => {
      const data = response.data
      if (data && !data.IsError) {
        this.$message({
          type: 'success',
          message: '监控点在线状态更新成功!'
        })
        this.refreshData()
      } else {
        this.$message({
          dangerouslyUseHTMLString: true, message: `${data.Message}`,
          type: 'warning'
        })
        console.log('监控点在线状态更新失败', data)
      }
    })
  }
  //关注列表
  public showFocus() {
    window.eventBus.$emit('openFocusVideoPoints')
  }
  public doPoint(index: number) {
    var item = this.list[index]
    //监控点管理 
    window.eventBus.$emit('openVideoPointsManage', item)
  }
  public doEdit(id: number) {
    const currentPath = `/VideoList/Edit/${id}`
    this.$router.push({ path: currentPath })
  }
  public doDel(id: number) {
    this.$confirm(`确定要删除吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      remove(id).then((response: { data: any }) => {
        const data = response.data
        if (data && !data.IsError) {
          this.$message({ type: 'success', message: '删除成功!' })
          this.refreshData()
        }
        else {
          this.$message({
            dangerouslyUseHTMLString: true, message: `${data.Message}`, type: 'warning'
          })
        }
      })
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消操作'
      })
    })
  }
  // 在当前路由改变，但是该组件被复用时调用
  @Watch('$route')
  public onRouteChange(route: any) {
    this.getPermission()
    const qt = this.queryTerm
    if (qt.CityId > 0) {
      this.cityChange(0)
    }
    this.doSearch()
  }
}
